import axios from 'axios';
import { interceptor } from '../../../utils/axios.interceptor';
import { adjuntosEndPoint, geometriesEndPoint } from '../../../utils/endPoints';
import { AOI, ApiGeometry } from '../../../models/Geometries';
import { getAOIImage } from './map.service';
import { Adjuntos } from '../../../models/Adjuntos';

const api = axios.create();
interceptor(api);

export class GeometryService {

  static getGeometries = async (taskId: number): Promise<ApiGeometry[]> => {
    const res = await api.get(geometriesEndPoint + '?tareaId=' + taskId);
    return res.data?.results;
  };

  static getGeometry = async (id: string): Promise<ApiGeometry> => {
    const res = await api.get(geometriesEndPoint + '/' + id);
    return res.data;
  };

  static saveGeometry = async (geometry: Partial<ApiGeometry>): Promise<ApiGeometry> => {
    console.log('saving geometry');
    const res = await api.post(geometriesEndPoint, geometry);
    return res.data;
  };

  static updateGeometry = async (geometry: Partial<ApiGeometry>, id: number): Promise<ApiGeometry> => {
    const res = await api.put(geometriesEndPoint + '/' + id, geometry);
    return res.data;
  };

  static deleteGeometry = async (geometryId: number): Promise<void> => {
    await api.delete(geometriesEndPoint + '/' + geometryId);
  };

  static deleteAttachment = async (adjuntoId: number): Promise<void> => {
    await api.delete(adjuntosEndPoint + '/' + adjuntoId);
  };

  static uploadAttachment = async (geometry: Partial<ApiGeometry>, aoi: AOI): Promise<Adjuntos[]> => {
    const formData = new FormData();
    // const blob = await (await fetch('file://' + adjunto.image)).blob();

    const image = await fetch(getAOIImage(aoi),{
      method: 'GET',
      headers: {
        Accept: 'image/png, */*',
        Authorization: 'Basic ' + btoa(
          process.env.REACT_APP_GEOSERVER_USER + ':' + process.env.REACT_APP_GEOSERVER_PASSWORD
        )
      }
    });
    const blob = await image.blob();
    // @ts-ignore
    formData.append('files', new Blob([blob], {type: 'image/png'}));
    formData.append('geometriaId', geometry.id + '');
    const res = await api.post<any>(adjuntosEndPoint, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  };

}

